import { Box, TextField, Typography } from "@mui/material";
import Slider from "@mui/material/Slider";
import React, { useState } from "react";
import { useTreeModifyContext } from "./TreeDataContext";
import { useAutosave } from "react-autosave";

export function BaseScaleNode(props: { scale: string }) {
  const { saveChangesAtPath } = useTreeModifyContext();

  let scaleNumber = parseFloat(props.scale);
  if (isNaN(scaleNumber)) {
    scaleNumber = 1;
  }
  const [scaleValue, setScaleValue] = useState(scaleNumber);
  useAutosave({
    data: scaleValue,
    onSave: (data) => {
      if (data !== null) {
        return saveChangesAtPath(scaleValue, ["baseScale"]);
      }
    },
    saveOnUnmount: false,
    interval: 500,
  });

  return (
    <Box className="horizontal-flex">
      <Typography>Base scale: </Typography>
      <TextField
        style={{ width: `${5}em` }}
        value={scaleValue}
        onChange={(event) => {
          const parsedValue = parseFloat(event.target.value);
          if (!isNaN(parsedValue)) {
            setScaleValue(parsedValue);
          }
        }}
      />
      <Slider
        key={"baseScaleSlider"}
        value={scaleValue}
        onChange={(event, value) => {
          if (typeof value === "number") {
            setScaleValue(value);
          }
        }}
        max={10}
        min={0.1}
        step={0.01}
        style={{ maxWidth: "40%" }}
      />
    </Box>
  );
}
